module.exports = __webpack_public_path__ + "static/me20-6e4d46bf7a28a60c717dc8ef640c6bc8.jpg";